<template>
  <div class="routing-detail">
    <div class="title custom-title">Routing Details</div>
    <validation-observer name="Routing" ref="validateRouting">
      <b-card class="b-card-bg">
        <b-row class="px-2">
          <b-col cols="12" lg="6">
            <validation-provider
              name="Quotation No."
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label>Quotation No.</label>

                <Select4
                  :disabled="readonly"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Quotation No."
                  v-model="value.quotation"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    label: 'id',
                    data: quotations,
                    fields: [
                      {
                        field: 'id',
                        label: 'Quotation No.',
                      },
                      {
                        field: 'exp_date',
                        label: 'Valid to',
                      },
                      {
                        field: 'total_cost',
                        label: 'Total cost',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Transit Port"
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label>Transit Port</label>

                <Select4
                  :disabled="readonly"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Transit Port"
                  @reload="loadPort"
                  v-model="value.transit_port"
                  :options="{
                    isSearch: true,
                    isReload: true,
                    value: 'code',
                    label: 'name',
                    data: ports,
                    fields: [
                      {
                        field: 'code',
                        label: 'Port code',
                      },
                      {
                        field: 'name',
                        label: 'port name',
                      },
                      {
                        field: 'country_code',
                        label: 'country_code',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Origin Port"
              #default="{ errors }"
              rules="required"
              :key="reload"
            >
              <b-form-group>
                <label class="flex"
                  >Origin Port <span class="red">*</span></label
                >
                <Select4
                  :disabled="readonly"
                  v-model="value.pol_port"
                  @reload="loadPort"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="POL/AOL"
                  :options="{
                    isSearch: true,
                    isReload: true,
                    value: 'code',
                    label: 'name',
                    data: ports,
                    fields: [
                      {
                        field: 'code',
                        label: 'Port code',
                      },
                      {
                        field: 'name',
                        label: 'port name',
                      },
                      {
                        field: 'country_code',
                        label: 'Country',
                      },
                    ],
                  }"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Delivery Port"
              #default="{ errors }"
              rules="required"
              :key="reload"
            >
              <b-form-group>
                <label class="flex"
                  >Delivery Port <span class="red">*</span></label
                >

                <Select4
                  :disabled="readonly"
                  v-model="value.pod_port"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="POD/AOD"
                  @reload="loadPort"

                  :options="{
                    isSearch: true,
                    isReload: true,
                    value: 'code',
                    label: 'name',
                    data: ports,
                    fields: [
                      {
                        field: 'code',
                        label: 'Port code',
                      },
                      {
                        field: 'name',
                        label: 'Port Name',
                      },
                      {
                        field: 'country_code',
                        label: 'Country',
                      },
                    ],
                  }"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BButton,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    Select2,
  },
  data() {
    return {
      check_country_pick_up: null,
      check_country_delivery: null,
      reload: 1,
    };
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
      "quotations",
    ]),
  },
  methods: {
    ...mapActions("masterData", ["fetchPort"]),

    async loadPort() {
      this.$loading.show();
      await this.fetchPort();
      this.$loading.hide();
    },
  },
  watch: {
    "value.pol_port": function (n, o) {
      if (n) {
        this.value.pol_name = n;
        this.check_country_pick_up = this.ports.filter(
          (item) => item.code === n
        )[0];
        if (
          this.check_country_pick_up &&
          this.check_country_pick_up.country_code == "VN"
        ) {
          this.value.isPOL_VN = true;
        } else {
          this.value.isPOL_VN = false;
        }
        if (this.check_country_pick_up && this.check_country_delivery) {
          if (
            this.check_country_pick_up.country_code === "VN" &&
            this.check_country_delivery.country_code === "VN"
          ) {
            this.value.pol_port = null;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Sai dịch vụ, vui lòng chọn dịch vụ Domestics",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          } else if (
            this.check_country_pick_up.country_code !== "VN" &&
            this.check_country_delivery.country_code !== "VN"
          ) {
            this.value.pol_port = null;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Chưa cung cấp dịch vụ này",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          }
        } else {
          // Xử lý khi check_country_pick_up hoặc check_country_delivery là undefined
        }
      }
    },
    "value.pod_port": function (n, o) {
      if (n) {
        this.value.pod_name = n;
        this.check_country_delivery = this.ports.filter(
          (item) => item.code === n
        )[0];
        if (this.check_country_delivery.country_code == "VN") {
          this.value.isPOD_VN = true;
        } else {
          this.value.isPOD_VN = false;
        }

        if (
          this.check_country_pick_up.country_code === "VN" &&
          this.check_country_delivery.country_code === "VN"
        ) {
          this.value.pol_port = null;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Sai dịch vụ, vui lòng chọn dịch vụ Domestics",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        } else if (
          this.check_country_pick_up.country_code != "VN" &&
          this.check_country_delivery.country_code != "VN"
        ) {
          this.value.pod_port = null;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Chưa cung cấp dịch vụ này",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          this.reload++;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.routing-detail {
  .custom-title {
    align-items: center;
    display: flex;
    height: 43px;
  }

  label {
    color: #000000;
    font-weight: 600;
  }

  .form-control {
    border: 0 !important;
  }

  .b-card-bg {
    height: 300px;

    @media (max-width: 992px) {
      height: 350px;
    }
  }
}
</style>
